import { useState, createContext, useMemo } from "react";

const PlanCopyConfContext = createContext();

export function PlanCopyConfContextProvider(props) {
	// Global
	const [crudConfOpen, setCrudConfOpen] = useState(false);

	const [crudModel, setCrudModel] = useState(null);

	const [mode, setMode] = useState("export");

	const defaultOrganization = useMemo(
		() => ({
			organization: props.plan?.organization ?? null,
			plan: props.plan,
		}),
		[JSON.stringify(props.plan?.organization)]
	);

	const [selectedOrganization, setSelectedOrganization] = useState({
		organization: props.plan?.organization ?? null,
		plan: props.plan,
	});

	const [copyPopup, setCopyPopup] = useState(false);

	const [selectedConf, setSelectedConf] = useState(null);

	const [selectedConfId, setSelectedConfId] = useState(null);

	const [planChapters, setPlanChapters] = useState(null);

	const [listConfs, setListConfs] = useState([]);

	const [listOrganizations, setListOrganizations] = useState([]);

	const [planData, setPlanData] = useState({});

	// Delete

	const [deleteModalOpen, setDeleteModalOpen] = useState(false);

	const [deleteConf, setDeleteConf] = useState({});

	const [deleteItem, setDeleteItem] = useState(null);

	const [updateListConf, setUpdateListConf] = useState(0);

	const [loadingCopyPlan, setLoadingCopyPlan] = useState({
		showDetail: false,
		editConf: false,
		planInfo: false,
		copiers: false,
	});

	const context = {
		crudConfOpen,
		setCrudConfOpen,

		crudModel,
		setCrudModel,

		selectedConf,
		setSelectedConf,

		selectedConfId,
		setSelectedConfId,

		copyPopup,
		setCopyPopup,

		planChapters,
		setPlanChapters,

		planData,
		setPlanData,

		listConfs,
		setListConfs,

		deleteModalOpen,
		setDeleteModalOpen,

		deleteConf,
		setDeleteConf,

		deleteItem,
		setDeleteItem,

		updateListConf,
		setUpdateListConf,

		listOrganizations,
		setListOrganizations,

		loadingCopyPlan,
		setLoadingCopyPlan,

		mode,
		setMode,

		selectedOrganization,
		setSelectedOrganization,
		defaultOrganization,
	};

	return (
		<PlanCopyConfContext.Provider value={context}>{props.children}</PlanCopyConfContext.Provider>
	);
}

export default PlanCopyConfContext;
